import React from "react";
import { BarChart2, PieChart } from "lucide-react";
import "./features.css";

const Features = () => {
    return (
        <div className="features-section">
            <h1 className="features-green-heading">FAST INSIGHTS
            </h1>
            <h2 className="features-header">Quickly Understand Any Industry <br></br> with Actionable Data
            </h2>
            <div className="features-container">


                <div className="features-heading">
                </div>
                <div className="features-card">
                    <div className="features-icon" style={{ color: "#2a8e9e" }}>
                        <BarChart2 size={60} />
                    </div>
                    <h2 className="features-title">Sectoral Deep Dives</h2>
                    <p className="features-description">
                        Comprehensive sector analysis including value chains, policy impact,
                        key indicators, and market dynamics.
                    </p>
                    <div className="features-list-container">
                        <ul className="features-list">
                            <li> Overview</li>
                            <li> Policy / Sectoral Boost</li>
                            <li> Companies</li>
                            <li> Order Book</li>
                        </ul>
                        <ul className="features-list">
                            <li> Value Chain</li>
                            <li> Key Indicators</li>
                            <li> Capex</li>
                        </ul>
                    </div>
                </div>
                <div className="features-card">
                    <div className="features-icon" style={{ color: "#2a8e9e" }}>
                        <PieChart size={60} />
                    </div>
                    <h2 className="features-title">Company Analysis</h2>
                    <p className="features-description">
                        In-depth company analysis covering product expertise, financials,
                        strategic initiatives, and risk assessment.
                    </p>
                    <div className="features-list-container">
                        <ul className="features-list">
                            <li> Product Expertise</li>
                            <li> Work Order</li>
                            <li> New Products</li>
                            <li> Policy/Sectoral Boost</li>
                        </ul>
                        <ul className="features-list">
                            <li> Revenue Breakdown</li>
                            <li> Capex</li>
                            <li> Emerging Opportunities</li>
                            <li> Risks</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default Features;
